import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { LandingComponent } from './views/landing/landing.component';
import { PreviewReportComponent } from './views/preview-report/preview-report.component';
import { CloseDayProcessComponent } from './views/closeday-process/closeday-process.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { EmailVerificationComponent } from './views/verification/verification';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'landing', component: LandingComponent },
  { path: 'preview', component: PreviewReportComponent },
  { path: 'closeday-running', component: CloseDayProcessComponent },
  { path: 'email-verification', component: EmailVerificationComponent },
  { path: '', component: LoginComponent },
  { path: '**', pathMatch: 'full', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponents = [LoginComponent, RegisterComponent]
